import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useEffect, useRef } from 'react';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';

const O: React.FC = () => {
    const { t } = useLang('shp3.O');
    const sectionRef = useRef<HTMLDivElement>(null);
    const webpOrJpg = useWebpOrJpg('#shp3-O');
    useEffect(() => {
        if (!sectionRef.current) return;
        const title = sectionRef.current?.querySelector('.title');
        const ani2El = sectionRef.current?.querySelector('.ani-2');
        const ani25El = sectionRef.current?.querySelector('.ani-2-5');
        const ani3El = sectionRef.current?.querySelectorAll('.ani-3');
        const ani35El = sectionRef.current?.querySelectorAll('.ani-3-5');
        const ani1 = AniContainer.create({
            triggerElement: sectionRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                title?.classList.add('enter');
                ani2El?.classList.add('enter');
                ani25El?.classList.add('enter');
                ani3El.forEach((el) => el.classList.add('enter'));
                ani35El.forEach((el) => el.classList.add('enter'));
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    title?.classList.remove('enter');
                    ani2El?.classList.remove('enter');
                    ani25El?.classList.remove('enter');
                    ani3El.forEach((el) => el.classList.remove('enter'));
                    ani35El.forEach((el) => el.classList.remove('enter'));
                }
            },
        });
        return () => {
            ani1.destroy?.();
        };
    }, []);
    return (
        <>
            {/* <EcoSpace /> */}
            <section
                className={`${css.section} shp3-O GtmModuleData-section`}
                id="shp3-O"
                data-section-id={'shp3-O'}
                data-section-title={t('title')}
                ref={sectionRef}
            >
                <div className="title ani-1">{t('title')}</div>
                <div className="list">
                    <div className="item ani-2">
                        <EcoImg
                            className=""
                            pc={webpOrJpg(
                                'https://websiteoss.ecoflow.com/upload/image/1760151735791/shp3-%E2%80%9330%E2%84%83%20to%2060%E2%84%83%20Operation.jpg',
                                'https://websiteoss.ecoflow.com/upload/image/1760151761503/shp3-%E2%80%9330%E2%84%83.webp',
                            )}
                            h5={webpOrJpg(
                                'https://websiteoss.ecoflow.com/upload/image/1760151735655/shp3-%E2%80%9330%E2%84%83%20to%2060%E2%84%83%20Operation%20(1).jpg',
                                'https://websiteoss.ecoflow.com/upload/image/1760151760469/shp3-%E2%80%9330%E2%84%83%20(1).webp',
                            )}
                        />
                        <div className="item-title ani-3">
                            {t.rich('item1_title', {
                                sub: (i: string) => <span className="sub">{i}</span>,
                            })}
                        </div>
                        <div className="item-desc ani-3">{t('item1_desc')}</div>
                    </div>
                    <div className="item ani-2-5">
                        <EcoImg
                            pc={webpOrJpg(
                                'https://websiteoss.ecoflow.com/upload/image/1759029938461/10%20Years.jpg',
                                'https://websiteoss.ecoflow.com/upload/image/1759042277491/10%20(1).webp',
                            )}
                            h5={webpOrJpg(
                                'https://websiteoss.ecoflow.com/upload/image/1759029937256/10%20Years%20(1).jpg',
                                'https://websiteoss.ecoflow.com/upload/image/1759042276384/10.webp',
                            )}
                        />
                        <div className="item-title ani-3-5">{t('item2_title')}</div>
                        <div className="item-desc ani-3-5">{t('item2_desc')}</div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default O;
